var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(_vm.isSingle) ? _c('div', {
    key: _vm.preventKey,
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))]), (_vm.confirmInfo.sLevel) ? _c('span', [_vm._v("【" + _vm._s(_vm.confirmInfo.sLevel) + "】")]) : _vm._e()])])], 1)], 1) : _c('div', {
    staticClass: "content-confirm-multiple"
  }, [_c('h1', [_vm._v("已勾选"), _c('span', [_vm._v(_vm._s(_vm.selectedCount))]), _vm._v("条记录")])]), _vm._v(" "), _c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "el-form",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定级",
      "prop": "secLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px",
      "display": "inline-block"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeLevel
    },
    model: {
      value: (_vm.ruleForm.secLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "secLevel", $$v)
      },
      expression: "ruleForm.secLevel"
    }
  }, _vm._l((_vm.paymentConf.list), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.secLevel,
        "value": option.secLevel
      }
    })
  }), 1), _vm._v(" "), (_vm.paymentConf.preUrl) ? _c('span', {
    staticClass: "ml-20"
  }, [_c('a', {
    attrs: {
      "href": _vm.paymentConf.preUrl,
      "target": "_blank"
    }
  }, [_vm._v("查看定级说明")])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "定薪",
      "prop": "paymentLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px",
      "display": "inline-block"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.paymentLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paymentLevel", $$v)
      },
      expression: "ruleForm.paymentLevel"
    }
  }, _vm._l((_vm.sStructureList), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.paymentLevel,
        "value": option.paymentLevel
      }
    })
  }), 1), _vm._v(" "), (_vm.paymentInfo) ? _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("offer标准：" + _vm._s(_vm.paymentMonth))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "row": 2,
      "placeholder": "请输入内容",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f24e7cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/modifySalaryDialog.vue
// module id = null
// module chunks = 